(() => {
  const ready = (callback) => {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', callback, { once: true });
    else callback();
  };

  ready(() => {
    document.querySelectorAll('[data-dhs-tabs]').forEach((tabs) => {
      const buttons = [...tabs.querySelectorAll('[role="tab"]')];
      const panels = [...tabs.querySelectorAll('[role="tabpanel"]')];
      const activate = (button) => {
        buttons.forEach((item) => {
          const active = item === button;
          item.setAttribute('aria-selected', active ? 'true' : 'false');
          item.tabIndex = active ? 0 : -1;
        });
        panels.forEach((panel) => { panel.hidden = panel.id !== button.getAttribute('aria-controls'); });
      };
      buttons.forEach((button, index) => {
        button.addEventListener('click', () => activate(button));
        button.addEventListener('keydown', (event) => {
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          let target = index;
          if (event.key === 'ArrowLeft') target = (index - 1 + buttons.length) % buttons.length;
          if (event.key === 'ArrowRight') target = (index + 1) % buttons.length;
          if (event.key === 'Home') target = 0;
          if (event.key === 'End') target = buttons.length - 1;
          buttons[target].focus();
          activate(buttons[target]);
        });
      });
    });

    document.querySelectorAll('[data-dhs-faq-search]').forEach((input) => {
      const section = document.querySelector('.dhs-faq-page');
      if (!section) return;
      input.addEventListener('input', () => {
        const query = input.value.trim().toLowerCase();
        section.querySelectorAll('[data-dhs-faq-item]').forEach((item) => {
          item.hidden = query !== '' && !item.textContent.toLowerCase().includes(query);
        });
        section.querySelectorAll('[data-dhs-faq-group]').forEach((group) => {
          group.hidden = !group.querySelector('[data-dhs-faq-item]:not([hidden])');
        });
      });
    });
    document.querySelectorAll('[data-dhs-faq-search-button]').forEach((button) => {
      button.addEventListener('click', () => button.parentElement.querySelector('[data-dhs-faq-search]')?.focus());
    });

    document.querySelectorAll('[data-dhs-blog-search]').forEach((input) => {
      const cards = [...document.querySelectorAll('[data-dhs-guide-card]')];
      const empty = document.querySelector('[data-dhs-blog-no-results]');
      input.addEventListener('input', () => {
        const query = input.value.trim().toLowerCase();
        cards.forEach((card) => { card.hidden = query !== '' && !card.textContent.toLowerCase().includes(query); });
        if (empty) empty.hidden = cards.some((card) => !card.hidden);
      });
    });
    document.querySelectorAll('[data-dhs-blog-search-button]').forEach((button) => {
      button.addEventListener('click', () => button.parentElement.querySelector('[data-dhs-blog-search]')?.focus());
    });

    document.querySelectorAll('[data-dhs-scroll]').forEach((button) => {
      button.addEventListener('click', () => {
        const target = document.querySelector(button.getAttribute('data-dhs-scroll'));
        if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });

    document.querySelectorAll('[data-dhs-article-content]').forEach((content) => {
      const toc = content.closest('.dhs-article-layout')?.querySelector('[data-dhs-toc]');
      if (!toc) return;
      const headings = [...content.querySelectorAll('h2, h3')];
      if (!headings.length) { toc.closest('.dhs-article-toc').hidden = true; return; }
      const list = document.createElement('ol');
      headings.forEach((heading, index) => {
        if (!heading.id) heading.id = `article-section-${index + 1}`;
        const item = document.createElement('li');
        if (heading.tagName === 'H3') item.className = 'is-subheading';
        const link = document.createElement('a');
        link.href = `#${heading.id}`;
        link.textContent = heading.textContent;
        item.append(link);
        list.append(item);
      });
      toc.append(list);
    });
  });
})();
